import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/Policy.module.css';

const Policy = () => {
    const [searchTerm, setSearchTerm] = React.useState('');
    const contentRef = React.useRef(null);

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchTerm && contentRef.current) {
            const content = contentRef.current.innerHTML.toLowerCase();
            const index = content.indexOf(searchTerm.toLowerCase());
            if (index !== -1) {
                const element = contentRef.current.childNodes[Array.from(contentRef.current.childNodes).findIndex(node => 
                    node.textContent.toLowerCase().includes(searchTerm.toLowerCase())
                )];
                const yOffset = -100; // Отступ в пикселях
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
            }
        }
    }

    return (
        <div className={styles.bdy}>
            <div className={styles.header}>
                <div className={styles.headerInner}>
                    <Link to='/'><img style={{height: '40px', display: 'flex'}} src='/img/logo/mainlogo-1070.png' alt='Поток' /></Link>
                    <Link to='/' className={styles.homeBtn}>Главная</Link>
                    <a>
                    <form onSubmit={handleSearch} style={{marginLeft: 'auto'}}>
                        <input 
                            type="text" 
                            value={searchTerm} 
                            onChange={(e) => setSearchTerm(e.target.value)} 
                            placeholder="Поиск по странице"
                        />
                        <button type="submit">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="search"><path fill="black" d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z"></path></svg>
                        </button>
                    </form>
                    </a>
                </div>
            </div>
            <div className={styles.main} ref={contentRef}>
                <div className={styles.headline}>
                    <h1>Пользовательское соглашение и политика конфиденциальности системы «Поток»</h1>
                </div>
                <div className={styles.backColor}>
                    <a className={styles.description}>Последнее обновление: 11.06.2025</a>
                </div>
                <div className={styles.backColor}>
                    <a className={styles.description}>Предыдущие версии:</a>
                    <div><a className={styles.description}>Версия от 02.01.2025:</a> <a className={`aWithLink ${styles.description}`} href='/policy-documents/policy-02-01-2025.pdf' download>Скачать</a></div>
                </div>
                <div className={styles.backColor}>
                <h2>1. Общие положения</h2>
                <a>Система «Поток» (далее — «Система») — сервис Союза «Саморегулируемая организация арбитражных управляющих «Альянс» (СОАУ), зарегистрированной по адресу: Нижегородская область, г. Нижний Новгород, ул Максима Горького, д. 52, помещ. п2, ОГРН 1025203032062, ИНН 5260111600.<br />Система предназначена для автоматизации и упрощения процессов ведения юридических дел арбитражными управляющими (АУ). Настоящие условия регламентируют основные принципы и условия её использования.</a>

                <h2>2. Сбор и использование данных</h2>
                <h3>2.1. Категории собираемых данных</h3>
                <a>Мы собираем следующие категории данных:</a>
                <ul>
                    <li>фамилия, имя, отчество (ФИО);</li>
                    <li>адрес электронной почты (email);</li>
                    <li>IP-адрес устройства, с которого выполняется вход;</li>
                    <li>регион деятельности;</li>
                    <li>пароль (хранится в зашифрованном виде);</li>
                    <li>настройки учетной записи;</li>
                    <li>активность на сайте (история действий);</li>
                    <li>данные о юридических делах, связанных с СОАУ (номер дела, категория, комментарии, файлы в зашифрованном виде) и о ведении и исполнении этапов/процедур по данным делам.</li>
                </ul>
                <h3>2.2. Цели использования данных</h3>
                <a>Собираемые данные используются для:</a>
                <ul>
                    <li>предоставления функционала системы;</li>
                    <li>организации процесса ведения дел;</li>
                    <li>персонализации настроек учетной записи;</li>
                    <li>защиты учетной записи (предотвращение повторной регистрации);</li>
                    <li>предотвращения несанкционированного доступа и злоупотребления;</li>
                    <li>контроля сроков и выполнения этапов исполнения.</li>
                </ul>
                <h2>3. Хранение и защита данных</h2>
                <h3>3.1. Безопасность данных</h3>
                <ul>
                    <li>Все пароли хранятся в зашифрованном виде с использованием современных криптографических стандартов.</li>
                    <li>Файлы и данные дел защищены шифрованием.</li>
                </ul>
                <h3>3.2. Токен аутентификации</h3>
                <a>Для авторизации пользователя в local storage браузера сохраняется токен учетной записи. Токен используется исключительно для обеспечения работы системы и имеет ограниченный срок действия.</a>
                <h3>3.3. Использование cookies</h3>
                <a>Мы используем cookies для:</a>
                <ul>
                    <li>отображения информационных баннеров;</li>
                    <li>хранения пользовательских предпочтений (если применимо). Пользователь может отключить cookies в настройках браузера, но это может повлиять на функциональность системы.</li>
                </ul>
                <h3>3.4. Сроки хранения данных</h3>
                <a>Персональные данные пользователей хранятся до удаления учетной записи или перевода в неактивный статус. Данные о делах сохраняются в архиве для обеспечения внутренней работы системы.</a>
                <h2>4. Права пользователей</h2>
                <a>Пользователи имеют право:</a>
                <ul>
                    <li>получить информацию о своих данных;</li>
                    <li>исправить или удалить данные;</li>
                    <li>ограничить обработку своих данных;</li>
                    <li>отказаться от использования cookies (действие приведет к некорректной работе системы);</li>
                    <li>запросить полное удаление персональных данных путем обращения на электронную почту: <a href='mailto:schepetov_av@mail.ru'>schepetov_av@mail.ru</a>.<br />Мы рассмотрим запрос и уведомим пользователя о результате. При этом, для обеспечения выполнения обязательств или защиты законных интересов СОАУ, минимально необходимые данные могут быть сохранены в зашифрованной форме.</li>
                </ul>
                <h2>5. Передача данных третьим лицам</h2>
                <ul>
                    <li>
                        Мы не передаем данные третьим лицам, за исключением:
                        <ul>
                            <li>хостинг-провайдера, обеспечивающего работу системы;</li>
                            <li>случаев, предусмотренных действуйющим законодательством Российской Федерации.</li>
                        </ul>
                    </li>
                </ul>
                <h2>6. Ответственность пользователей</h2>
                <ul>
                    <li>Пользователь обязан обеспечить конфиденциальность пароля и не передавать его третьим лицам.</li>
                    <li>Мы не несем ответственности за утечку данных, если она произошла по вине пользователя.</li>
                </ul>
                <h2>7. Изменения в политике</h2>
                <a>Мы оставляем за собой право вносить изменения в данное соглашение. О существенных изменениях пользователи будут уведомлены заранее.</a>
                <h2>8. Согласие пользователя</h2>
                <a>Используя Систему, пользователь подтверждает свое согласие с настоящими условиями.</a>
                <h2>9. Юридические вопросы и обращения</h2>
                <a>Если у пользователя возникают юридические вопросы или требования, касающиеся системы, они могут обратиться по следующему адресу электронной почты СОАУ: </a><a style={{margin: '0', width: 'fit-content'}} href='mailto:schepetov_av@mail.ru'>schepetov_av@mail.ru</a>
                <h1></h1>
                </div>
            </div>
        </div>
    )
}

export default Policy;